import { OverlayManagerService } from './../../services/overlay-manager.service';
import { SyncOverlayService } from './../../services/sync-overlay.service';
import { LocalCacheManager } from './../../api/managers/local-cache.manager';
import { LoggingService } from './../../services/logging.service';
import { ErrorHandlerService } from './../../services/error-handler.service';
import { LoginAndUserManagerService } from './../../api/managers/login-and-user-manager.service';

import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { concatMap, map, mergeMap, tap, catchError, exhaustMap, switchMap } from 'rxjs/operators';
import { authActionTypes, UserDetails } from './auth.actions';
import { of, Observable, observable, timer } from 'rxjs';
import { Constants } from './../../core/constants';

@Injectable()
export class AuthEffects {
    Constants = Constants;
    APPLICATION_TIMEOUT_TIME = 1000 * 1;

    login$ = createEffect(() =>
        this.actions$.pipe(
            ofType(authActionTypes.LoginIn),
            exhaustMap(action =>
                this.loginAndUserManagerService.login(action.email, action.password).pipe(
                    map((user) => authActionTypes.LoginSuccess({ user: user, rememberMe: action.rememberMe })),
                    catchError(error => of(authActionTypes.LoginFailure({ error: error })))
                )
            )
        )
    );

    userDetails$ = createEffect(() =>
        this.actions$.pipe(
            ofType(authActionTypes.UserDetails),
            exhaustMap(action =>
                this.loginAndUserManagerService.getUserDetails().pipe(
                    map((user) => authActionTypes.UserDetailsSuccess({ user: user })),
                    catchError(error => of(authActionTypes.LoginFailure({ error: error })))
                )

            )
        )
    );

    loginSuccess$ = createEffect(() =>
        this.actions$.pipe(
            ofType(authActionTypes.LoginSuccess),
            tap((action) => {
                if (action && action.user && action.user !== null && action.user.Token) {

                    LoggingService.log('User successfully logged in!', this);
                    this.loginAndUserManagerService.currentUser = action.user;
                    this.localCacheManager.accessToken = action.user.Token;
                    this.localCacheManager.userId = action.user.Id;
                    this.localCacheManager.rememberMe = action.rememberMe;
                    this.localCacheManager.emailAddress = action.rememberMe ? action.user.Email : '';
                    localStorage.setItem('appVersion', this.Constants.AppVersion);
                    this.router.navigate([`${this.loginAndUserManagerService.redirectUrl}`]);
                }
                else {
                    this.overlayManagerService.hideProcessingOverlay.next();
                    ErrorHandlerService.handleError(this, new Error('User login failed'), 'onLogin()', false);

                }

            })
        ),
        { dispatch: false }
    );

    loginFailuer$ = createEffect(() =>
        this.actions$.pipe(
            ofType(authActionTypes.LoginFailure),
            tap((action) => {
                this.overlayManagerService.hideProcessingOverlay.next();
                ErrorHandlerService.handleError(this, action.error['error'], 'onLogin()', false);
                this.overlayManagerService.hideProcessingOverlay.next();
            })
        ),
        { dispatch: false }
    );

    logout$ = createEffect(() =>
        this.actions$.pipe(
            ofType(authActionTypes.LogOut),
            map(() => authActionTypes.LogOutSuccess())
        )
    );

    userDetailsSuccess$ = createEffect(() =>
        this.actions$.pipe(
            ofType(authActionTypes.UserDetailsSuccess),
            tap((action) => {
                if (action && action.user.Token) {
                    LoggingService.log('User details get Successfully!', this);
                    this.router.navigate(['/dashboard']);
                }
                else {
                    ErrorHandlerService.handleError(this, new Error('User login failed'), 'WelcomePageComponent', false);
                }
            })
        ),
        { dispatch: false }
    );

    constructor(private loginAndUserManagerService: LoginAndUserManagerService,
        private actions$: Actions,
        private overlayManagerService: OverlayManagerService,
        private localCacheManager: LocalCacheManager,

        private router: Router) { }

}
